import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { Separation } from 'src/app/shared/models/separation';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
@Component({
  selector: 'app-terminantion-emp-appeal',
  templateUrl: './terminantion-emp-appeal.component.html',
  styleUrls: ['./terminantion-emp-appeal.component.scss']
})
export class TerminantionEmpAppealComponent implements OnInit {
public separations: Separation[] = [];
  public context: Context;
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private separationService: SeparationService,
    private router: Router,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.context = this.authService.getContextData();
    if (this.context?.employeeId) {
      this.getTerminations()
    }
  }

  private getTerminations(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.separations = [];
      }
      this.separationService.getTerminations(false).subscribe({
        next: (separations: Separation[]) => {
          this.separations = separations.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public upsertSeparation(separation?: Separation) {
    if (!this.privilege.canEdit) return;
    this.router.navigate(['/separation/termination-wizard'],
      { queryParams: { type: "TERMINATION_APPEAL", sId: separation?.id } });

  }

}
